import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function LessCircleFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12ZM17 12C17 12.5523 16.5523 13 16 13H8C7.44771 13 7 12.5523 7 12C7 11.4477 7.44771 11 8 11H16C16.5523 11 17 11.4477 17 12Z"
				fill="currentColor"
			/>
		</svg>
	);
}

LessCircleFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default LessCircleFilledIcon;
